var map = {
	"./SE162321000255/footer.svg": "2gRv",
	"./SE2321000016/footer.svg": "CE4i"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ldYY";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/regioner ^\.\/.*\/footer\.svg$
// module id = ldYY
// module chunks = 1